import React, { FC } from "react";
import { useScreenSize } from "../../../../hooks/useScreenSize";
import { Cart, CartProps } from "../Cart";
import { Location, LocationProps } from "../Location";
import { Search, SearchBarProps } from "../Search";
import { User, UserProps } from "../User";

export interface HeaderRightProps {
  accountAsNavLink?: boolean;
  authUsersOnly?: boolean;
  location?: LocationProps;
  searchBar?: SearchBarProps;
  cart?: CartProps;
  user: UserProps;
}

export const HeaderRight: FC<HeaderRightProps> = ({
  accountAsNavLink,
  authUsersOnly,
  location,
  searchBar,
  cart,
  user,
}) => {
  const { isMobile } = useScreenSize();

  return (
    <>
      {location && !isMobile && <Location location={location} />}
      {searchBar?.onSearchClicked && searchBar.showSearchBar && (
        <Search
          isLoggedIn={user.isLoggedIn}
          onSearchClicked={searchBar.onSearchClicked}
        />
      )}
      {!accountAsNavLink && <User user={user} />}
      {/*
        Show the cart if either:
          - authUsersOnly is false (tenant allows guest users)
          - the user is logged in
      */}
      {(!authUsersOnly || user.isLoggedIn) && cart && <Cart cart={cart} />}
    </>
  );
};
